<x-chartist [type]="'Pie'" [data]="simplePieData" [options]="simplePieOptions" class="height-300">
</x-chartist>